import React, { useEffect } from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import FounderStory from './components/FounderStory';
import TeamSection from './components/TeamSection';
import ValuesSection from './components/ValuesSection';
import ProcessSection from './components/ProcessSection';
import RecognitionSection from './components/RecognitionSection';
import CultureSection from './components/CultureSection';
import EngagementSection from './components/EngagementSection';

const AboutUsPage = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Update document title
    document.title = 'About Us - The Singh Creations | Digital Transformation Partners';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription?.setAttribute('content', 'Discover the Singh Creations- where artistry meets engineering. Learn about our team, values, process, and commitment to digital transformation excellence.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      {/* Hero Section */}
      <HeroSection />
      {/* Founder's Story */}
      <FounderStory />
      {/* Team Section */}
      <TeamSection />
      {/* Values Section */}
      <ValuesSection />
      {/* Process Section */}
      <ProcessSection />
      {/* Recognition Section */}
      <RecognitionSection />
      {/* Culture Section */}
      <CultureSection />
      {/* Engagement Section */}
      <EngagementSection />
      {/* Footer */}
      <footer className="bg-secondary text-white py-12">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="md:col-span-2">
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-10 h-10 bg-gradient-to-br from-primary to-accent rounded-lg flex items-center justify-center">
                  <svg viewBox="0 0 24 24" className="w-6 h-6 text-white" fill="currentColor">
                    <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
                  </svg>
                </div>
                <div>
                  <h3 className="text-xl font-bold">Singh Creations</h3>
                  <p className="text-sm text-white/70">Digital Atelier</p>
                </div>
              </div>
              <p className="text-white/80 mb-6 max-w-md">
                Where artistry meets engineering. We craft digital experiences that elevate brands and create meaningful connections between businesses and their audiences.
              </p>
              <div className="text-sm text-white/60">
                <p>&copy; {new Date()?.getFullYear()} Singh Creations. All rights reserved.</p>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-semibold mb-4">Company</h4>
              <div className="space-y-2">
                <a href="/about" className="block text-white/70 hover:text-white brand-transition">About Us</a>
                <a href="/services" className="block text-white/70 hover:text-white brand-transition">Services</a>
                <a href="#" className="block text-white/70 hover:text-white brand-transition">Portfolio</a>
                <a href="#" className="block text-white/70 hover:text-white brand-transition">Careers</a>
              </div>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-semibold mb-4">Contact</h4>
              <div className="space-y-2 text-white/70">
                <p>Delhi, India</p>
                <p>+91-7982843491</p>
                <p>singhcreations23@gmail.com</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AboutUsPage;